// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2V86K","file":"styles_file__-Ut_w"};